import React from "react";

export default function DTLRules() {
  return (
    <div className="modal-body">
      <div>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '\n        .rules-section .row.row5 {\n            margin-left: -5px;\n            margin-right: -5px;\n        }\n        .rules-section .pl-2 {\n            padding-left: .5rem !important;\n        }\n        .rules-section .pr-2 {\n            padding-right: .5rem !important;\n        }\n        .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] {\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n        .rules-section\n        {\n            text-align: left;\n            margin-bottom: 10px;\n        }\n        .rules-section .table\n        {\n            color: #fff;\n            border:1px solid #444;\n            background-color: #222;\n            font-size: 12px;\n        }\n        .rules-section .table td, .rules-section .table th\n        {\n            border-bottom: 1px solid #444;\n        }\n        .rules-section ul li, .rules-section p\n        {\n            margin-bottom: 5px;\n        }\n        .rules-section::-webkit-scrollbar {\n            width: 8px;\n        }\n        .rules-section::-webkit-scrollbar-track {\n            background: #666666;\n        }\n\n        .rules-section::-webkit-scrollbar-thumb {\n            background-color: #333333;\n        }\n        .rules-section .rules-highlight\n        {\n            color: #FDCF13;\n            font-size: 16px;\n        }\n        .rules-section .rules-sub-highlight {\n            color: #FDCF13;\n            font-size: 14px;\n        }\n        .rules-section .list-style, .rules-section .list-style li\n        {\n            list-style: disc;\n        }\n        .rules-section .rule-card\n        {\n            height: 20px;\n            margin-left: 5px;\n        }\n        .rules-section .card-character\n        {\n            font-family: Card Characters;\n        }\n        .rules-section .red-card\n        {\n            color: red;\n        }\n        .rules-section .black-card\n        {\n            color: black;\n        }\n        .rules-section .cards-box\n        {\n            background: #fff;\n            padding: 6px;\n            display: inline-block;\n            color: #000;\n            min-width: 150px;\n        }\n    ',
          }}
        />
        <div className="rules-section">
          <ul className="pl-4 pr-4 list-style">
            <li>
              20-20 DTL(Dragon Tiger Lion) is a 52 playing cards game, In DTL
              game 3 hands are dealt: for each 3 player. The player will bets
              which will win.{" "}
            </li>
            <li>
              The ranking of cards is, from lowest to highest: Ace, 2, 3, 4,
              5, 6, 7,8, 9, 10, Jack, Queen and King when Ace is “1” and King
              is “13”.
            </li>
            <li>
              On same card with different suit, Winner will be declare based
              on below winning suit sequence.
              <p />
              <div className="cards-box">
                <span className="card-character black-card ml-1">
                  1
                  {
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMA2RoDdhkwDsLpz292znc9A5fj4PNPJMl5Q&s"
                      alt="Black Spade"
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                </span>
                <span>1st</span>
              </div>
              <p />
              <p />
              <div className="cards-box">
                <span className="card-character red-card ml-1">
                  1
                  {
                    <img
                      src="https://cdn.vectorstock.com/i/1000v/56/73/playing-cards-heart-vector-20655673.png"
                      alt="Black Spade"
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                </span>
                <span>2nd</span>
              </div>
              <p />
              <p />
              <div className="cards-box">
                <span className="card-character black-card ml-1">
                  1
                  {
                    <img
                      src="https://img.freepik.com/free-vector/club-playing-card-symbol_1308-80941.png?size=626&ext=jpg&ga=GA1.1.1880011253.1728864000&semt=ais_hybrid-rr-similar"
                      alt="Black Spade"
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                </span>
                <span>3rd</span>
              </div>
              <p />
              <p />
              <div className="cards-box">
                <span className="card-character red-card ml-1">
                  1
                  {
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt12a0Rsh5JGx-tEYJFHFnKvRzFOf3wQxdBg&s"
                      alt="Black Spade"
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                </span>
                <span>4th</span>
              </div>
              <p />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
